// extracted by mini-css-extract-plugin
export default {"card":"Card_card__UhCiT","bordered":"Card_bordered__xrfns","borderless":"Card_borderless__Q0Thd","hoverableCard":"Card_hoverableCard__3FQxU"};